import {
  ProductJobDetailResponse,
  ProductJobItem,
  ProductJobListResponse,
} from "../types/product-bulk-import"

export class ProductBulkImport {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  create(
    vendorId: string,
    body: unknown,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductJobItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/bulk-import-products`,
        {
          method: "POST",
          headers: {
            ...headers,
            "content-type": null,
          },
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductJobListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/bulk-import-products`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductJobDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/bulk-import-products/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }
}
